<template>

    <div class="offcanvas offcanvas-end  w-100 bg-transparent" tabindex="-1" id="discuss_question"
         aria-labelledby="discuss_questionLabel">
        <div class="  d-flex d-flex justify-content-end overflow-auto">
            <div class=" col-md-8 bg-light rounded overflow-auto">
                <div class="offcanvas-header shadow">
                    <h5 class="offcanvas-title" id="discuss_questionLabel">Discuss</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close">X</button>
                </div>
                <div class="offcanvas-body">
                    <form @submit.prevent="create">
                        <div class="shadow rounded border-0 card">
                            <div class="card-body">
                                <h6 class="card-title mb-3">Leave A Discuss :</h6>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="mb-3">
                                            <!--                                    <label class="form-label form-label">Your Comment</label>-->
                                            <div class="form-icon position-relative"><i>
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                     stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                     stroke-linejoin="round"
                                                     class="feather feather-message-circle fea icon-sm icons">
                                                    <g>
                                                        <path
                                                            d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>
                                                    </g>
                                                </svg>
                                            </i></div>

                                            <textarea v-model="item.comment" class="form-control ps-5" rows="2"
                                                      placeholder="Your Comment"
                                                      :class="{ 'is-invalid' : isInvalid('comment')}"
                                                      required></textarea>
                                            <div class="invalid-feedback" v-if="isInvalid('comment')">
                                                {{ isInvalid('comment') }}
                                            </div>

                                        </div>
                                    </div>
                                    <!--                            <div class="col-md-12">-->
                                    <!--                                <div class="mb-3"><label class="form-label form-label">Name <span-->
                                    <!--                                    class="text-danger">*</span></label>-->
                                    <!--                                    <div class="form-icon position-relative"><i>-->
                                    <!--                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"-->
                                    <!--                                             stroke="currentColor" stroke-width="2" stroke-linecap="round"-->
                                    <!--                                             stroke-linejoin="round" class="feather feather-user fea icon-sm icons">-->
                                    <!--                                            <g>-->
                                    <!--                                                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>-->
                                    <!--                                                <circle cx="12" cy="7" r="4"></circle>-->
                                    <!--                                            </g>-->
                                    <!--                                        </svg>-->
                                    <!--                                    </i></div>-->
                                    <!--                                    <input id="name" name="name" placeholder="Name" required="" type="text"-->
                                    <!--                                           class="form-control ps-5 form-control"></div>-->
                                    <!--                            </div>-->
                                    <div class="col-md-12">
                                        <div class="send d-grid w-50">
                                            <button type="submit" class="btn btn-primary">Submit a new
                                                question/comment
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>

                    <div class="shadow rounded border-0 mt-4 card">
                        <div class="card-body"><h5 class="card-title mb-0 border-bottom pb-3">Discussions and questions
                            :</h5>
                            <ul class="media-list list-unstyled mb-0">
                                <template class="mt-4 border-bottom" v-for="item in items?.data" :key="item.id">
                                    <discuss_question_comment :comment="item"></discuss_question_comment>
                                </template>
                            </ul>
                        </div>
                    </div>
                    <Bootstrap5Pagination
                        class="mb-0"
                        :data="items"
                        :limit="2"
                        :show-disabled="false"
                        :size="'default'"
                        :align="'center'"
                        @pagination-change-page="getResults"
                    />

                </div>
            </div>
        </div>
    </div>

</template>

<script>
import {useToast} from "vue-toastification";
import axios from "axios";
import Discuss_question_comment from "./discuss_question_comment.vue";

const toast = useToast();

export default {
    components: {Discuss_question_comment},
    props: {
        question: {
            required: true
        }
    },
    watch: {
        'question': function (newVal) {
            if (newVal) {
                this.getResults();
            }
        },
    },
    data() {
        return {
            items: [],
            item: {},
            validationErrors: null,
            error_message: null,
        }
    },
    created() {
        this.getResults();
    },
    methods: {
        isInvalid(name) {
            return this.validationErrors != null ? this.validationErrors[name]?.join() : false;
        },
        getResults(page = this.$route?.query?.page ?? 1) {

            const id = toast.info('Getting content ...', {icon: 'fa-solid fa-download'});

            axios.get('question_discussions', {
                params: {
                    'page': page,
                    'question_id': this.question?.id,
                    'subscribe_id': this.$route?.params?.subscribe_id
                }
            }).then(response => {
                toast.dismiss(id);
                this.items = response.data;
                // this.$router.replace({ name: "question_discussions.index", query: { 'page' : page,'comment' : this.q.comment  }  });
            }).catch(error => {
                toast.dismiss(id);
                toast.error(`Error: ${error.response ? error.response.data.message : 'An error occurred'}`);
            });

        },
        create() {

            const id = toast.info('creating ...', {icon: 'fa-solid fa-cloud-arrow-up'});

            const that = this;
            this.validationErrors = null;
            this.error_message = null;


            let formData = new FormData();
            Object.entries(this.item).forEach(([key, value]) => {
                formData.append(key, value);
            });
            formData.append('question_id', this.question.id);
            formData.append('subscribe_id', this.$route?.params?.subscribe_id);

            axios.post('question_discussions',
                formData
            ).then(response => {
                toast.dismiss(id);

                toast.success(response.data.message, {
                    timeout: 3000,
                }, {icon: 'fa-solid fa-circle-check'});

                this.items?.data?.unshift(response.data.data);
                // add +1 to question.discussions_count
                this.question.discussions_count = this.question.discussions_count + 1;


                this.item = {};
                // this.$router.push({name: 'home'});

            }).catch(function (error) {
                toast.dismiss(id);
                if (error.response) {
                    that.validationErrors = error.response.data.errors;
                    that.error_message = error.response.data.message;
                    toast.error(error.response.data.message, {
                        timeout: 3000,
                    }, {icon: 'fa-solid fa-circle-exclamation'});
                }
            });

        }
    }
};
</script>

<style scoped>
.btn {
    cursor: pointer;
}
</style>
